<template>
  <header class="card-header">
    <slot />
  </header>
</template>

<script type="text/babel">
export default {
  name: 'CommunicationCardHeader',
}
</script>
